import { render, staticRenderFns } from "./Economy.vue?vue&type=template&id=6fd22f30&"
import script from "./Economy.vue?vue&type=script&lang=js&"
export * from "./Economy.vue?vue&type=script&lang=js&"
import style0 from "./Economy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports